"use client";

import React from "react";

export interface Statistic {
  value: string;
  label: string;
}

export interface RedefiningStandardsProps {
  title?: string;
  subtitle?: string;
  statistics?: Statistic[];
  image?: string;
  imageAlt?: string;
  onMeetTherapistsClick?: () => void;
}

export function RedefiningStandards({
  title = "Alli is Redefining Therapy Standards for Canadians",
  subtitle = "High therapy costs have burdened Canadians for too long! We're here to change that with quality, affordable care.",
  statistics = [
    { value: "38,000+", label: "Canadians Received Care" },
    { value: "170+", label: "Canadian Therapists" },
    { value: "190,000+", label: "Sessions Conducted" }
  ],
  image = "https://cdn.prod.website-files.com/65154e68ae1ad53c6e8aaa1a/651d2d8c42ddf9001f7ab058_landing%20image.png",
  imageAlt = "Alli therapy session",
  onMeetTherapistsClick
}: RedefiningStandardsProps) {
  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-[1.5fr_1fr] gap-16 items-center">
          {/* Left content */}
          <div className="order-2 lg:order-1">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-[1.1]">
              {title}
            </h2>
            <p className="text-xl text-gray-600 mb-16 leading-relaxed">
              {subtitle}
            </p>
            
            {/* Statistics */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
              {statistics.map((stat, index) => (
                <div key={index} className="bg-gray-50 rounded-2xl px-5 py-7 text-center min-w-0">
                  <div className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
                    {stat.value}
                  </div>
                  <div className="text-sm text-gray-600">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
            
            {/* CTA Button */}
            <div className="flex items-center gap-4">
              <button 
                onClick={onMeetTherapistsClick}
                className="bg-primary-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-primary-700 transition-colors"
              >
                Meet Our Therapists
              </button>
              <span className="text-sm text-gray-500">See their credentials & specialties</span>
            </div>
          </div>
          
          {/* Right image */}
          <div className="order-1 lg:order-2">
            <div className="relative overflow-hidden rounded-3xl">
              <img 
                src={image}
                alt={imageAlt}
                className="w-full h-full object-cover"
                style={{ aspectRatio: '1/1' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}